export function normalizeBasePath(value: string): string {
  const trimmed = value.trim();
  if (!trimmed || trimmed === "/") return "/";
  return `/${trimmed.replace(/^\/+|\/+$/g, "")}/`;
}

export function resolveAppPath(basePath: string, value: string): string {
  if (!value) return "";
  if (/^[a-z][a-z\d+.-]*:/i.test(value) || value.startsWith("//")) return value;
  return `${normalizeBasePath(basePath)}${value.replace(/^\/+/, "")}`;
}
